export const PDF_ERROR = 'Envie um arquivo PDF.'

export const ADDITIVE_DESCRIPTION_ERROR = 'Informe a descrição do aditivo.'

export const FILE_UNAVAILABLE_ERROR = 'O arquivo não está mais disponível. Envie novamente.'

export const RENEWAL_AUTOMATIC = 'automatic'
export const RENEWAL_BY_DATE = 'date'

const ADDITIVE_FIELDS = ['description', 'signed_at', 'effective_from']

const pendingFiles = new Map()

let sequence = 0

export function isPdf(file) {
  if (!file)
    return false

  return file.type === 'application/pdf' || String(file.name).toLowerCase().endsWith('.pdf')
}

export function stagePendingFile(file) {
  sequence += 1

  const token = `pending_${sequence}`
  pendingFiles.set(token, file)

  return {
    name: file.name,
    size: file.size,
    uploaded_at: new Date().toISOString(),
    pending_token: token
  }
}

export function takePendingFile(meta) {
  if (!meta || !meta.pending_token)
    return null

  return pendingFiles.get(meta.pending_token) || null
}

export function discardPendingFile(meta) {
  if (meta && meta.pending_token)
    pendingFiles.delete(meta.pending_token)
}

export function clearPendingFiles() {
  pendingFiles.clear()
}

export function isPending(meta) {
  return !!(meta && meta.pending_token)
}

export function additiveChanged(additive, previous) {
  if (isPending(additive.file))
    return true

  if (!additive.file && previous.file)
    return true

  return ADDITIVE_FIELDS.some(field => (additive[field] || null) !== (previous[field] || null))
}

function documentChanges(account, pristine) {
  const current = (account.contract_document || {}).file
  const previous = ((pristine || {}).contract_document || {}).file

  if (isPending(current))
    return [{ action: 'attach_file', file: takePendingFile(current) }]

  if (!current && previous)
    return [{ action: 'remove_file' }]

  return []
}

function additiveChanges(account, pristine) {
  const current = account.contract_additives || []
  const previous = (pristine || {}).contract_additives || []
  const changes = []

  current.forEach(additive => {
    const original = previous.find(item => item.id === additive.id)

    if (!original)
      return changes.push({ action: 'create_additive', additive: additive, file: takePendingFile(additive.file) })

    if (additiveChanged(additive, original)) {
      changes.push({
        action: 'update_additive',
        additive: additive,
        file: takePendingFile(additive.file),
        removeFile: !additive.file && !!original.file
      })
    }
  })

  previous.forEach(original => {
    if (!current.some(item => item.id === original.id))
      changes.push({ action: 'remove_additive', additive: original })
  })

  return changes
}

export function pendingContractChanges(account, pristine) {
  return [...documentChanges(account, pristine), ...additiveChanges(account, pristine)]
}

export function additivePayload(additive) {
  return ADDITIVE_FIELDS.reduce((payload, field) => {
    payload[field] = additive[field] || null
    return payload
  }, {})
}
